<template xmlns="http://www.w3.org/1999/html">
  <b-container id="annonce-add-reward-container" class="d-flex flex-column">
    <div id="annonce-add-reward-title-container" class="row pt-md-3 pt-2">
      <div class="col-12 col-md-6 d-flex justify-content-center">
        <div class="custom-width ml-md-5 justify-content-between d-md-flex align-items-center">
          <back-arrow :title="$t('annonce.create.additional.reward.page.title')"/>
        </div>
      </div>
    </div>

    <div id="annonce-add-reward-sub-container" class="row pt-md-5 pt-2">
      <div id="annonce-add-reward-sub-container-left" class="col-12 col-md-6 col-title">
<!--        <div class="custom-width ml-md-5 d-flex align-items-center">-->
<!--          <h1 class="page-title w-75">-->
<!--            {{ $t('annonce.create.additional.reward.page.title') }}</h1>-->
<!--        </div>-->
        <div class="custom-width ml-md-5 mt-3">
          <span class="bold-text">{{ $t('annonce.create.additional.reward.title') }}</span>
        </div>
        <div class="custom-width ml-md-5 mt-3">
          <h1 class="content">{{ $t('annonce.create.additional.reward.description') }}</h1>
        </div>
        <div class="custom-width ml-md-5 mt-3">
          <p class="link-main-color cursor-pointer" @click="$bvModal.show('additional-reward-info-modal')">
            {{ $t('annonce.create.additional.reward.know.more') }}</p>
        </div>
      </div>

      <div id="annonce-add-reward-sub-container-right"
           class="col-12 col-md-6 d-flex justify-content-center justify-content-md-start">

        <annonce-create-additional-reward-step
          :annonce="this.annonce"
          :need-to-disable-options="needToDisableOptions"
          @updateAnnonce="updateAnnonce"
        ></annonce-create-additional-reward-step>
      </div>
    </div>

    <div class="footer-annonce-add-reward">
      <div class="row h-100">
        <div class="col-md-12  d-flex align-items-center mb-2 ml-2 mr-2 justify-content-around">
          <div class="hide">

          </div>
          <b-button
              v-if="!hasValidatedSupplement"
              class="mr-1"
              variant="primary"
              @click="validate"
              :disabled="isLoading || !hasSelectedAnOption || (hasSelectedAnOption && annonce.additionnalRewardLevel.value === null)">
            <div v-if="!isLoading"
                 class="pr-4 pl-4">
              {{$t('Validate')}}
            </div>
            <b-spinner v-else class="button-spinner"></b-spinner>
          </b-button>
        </div>
      </div>
    </div>

    <AnnoncePaymentPromiseModal
      :is-reward-edit="true"
      @close="closedPaymentModal"
      @publish="handlePaymentSuccess"
    ></AnnoncePaymentPromiseModal>

  </b-container>


</template>

<script>
import BackArrow from "../../components/b122/BackArrow";
import api from "../../services/api";
import AnnonceCreateAdditionalRewardStep from "./AnnonceCreate/AnnonceCreateAdditionalRewardStep";
import AnnoncePaymentPromiseModal from "./AnnoncePaymentPromiseModal";

export default {
  name: "AnnonceAdditionnalRewardEdit",

  components: {
    BackArrow,
    AnnonceCreateAdditionalRewardStep,
    AnnoncePaymentPromiseModal
  },

  data() {
    return {
      annonceId: this.$route.params.annonceId,
      isLoading: false,
      annonce: this.initAnnonce(),
      needToDisableOptions: false,

      initialValue: null,
      initialAmount: null,
      hasSelectedAnOption: false,

      hasValidatedSupplement: false,
      totalToPay: 0,
    }
  },

  async mounted() {
    if (this.annonceId) {
      await this.fetchAnnonce()
    }
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
  },

  methods: {

    beforeUnloadHandler(event) {
      event.preventDefault();
      event.returnValue = '';
    },

    updateAnnonce(annonce) {
      if(annonce.additionnalRewardLevel.value !== this.initialValue){
        this.hasSelectedAnOption = true
        this.totalToPay = this.annonce.additionnalRewardAmount.value
      }

      this.annonce = {...annonce}
    },

    initAnnonce() {
      return {
        additionnalRewardLevel: {state: null, invalidFeedback: null, value: null},
        additionnalRewardAmount: {state: null, invalidFeedback: null, value: null},
      };
    },

    async fetchAnnonce() {
      await api
        .get(`/annonce/${this.annonceId}`)
        .then(async response => {
          this.initialValue = response.data.additionnalRewardLevel
          this.initialAmount = response.data.additionnalRewardAmount
          this.$set(this.annonce.additionnalRewardLevel, 'value', response.data.additionnalRewardLevel);
          this.$set(this.annonce.additionnalRewardAmount, 'value', response.data.additionnalRewardAmount);
          if(response.data.additionnalRewardLevel !== null && response.data.additionnalRewardLevel > 0){
            this.needToDisableOptions = true
          }
        })
        .catch((error) => {
          this.errorToast()
        })
    },

    validate(){
      if(this.hasSelectedAnOption){
        this.$bvModal.show('annonce-payment-promise-modal')
      }
    },

    closedPaymentModal() {
      this.$bvModal.hide("annonce-payment-promise-modal")
      this.isLoading = false
    },


    handlePaymentSuccess(){
      this.hasValidatedSupplement = true

      //Il faut ajouter la valeur initial du reward au montant de l'extension payée
      let total = this.annonce.additionnalRewardAmount.value + (this.initialAmount != null ? this.initialAmount : 0)
      let data = new FormData()
      data.append('annonceId', this.annonceId)
      data.append('additionnalRewardLevel', this.annonce.additionnalRewardLevel.value)
      data.append('additionnalRewardAmount', total)


      api({
        method: "POST",
        url: `/annonce/validateAdditionalRewardSupplement`,
        data: data
      })
        .then((response)=>{
          if(response.data === true){
            this.successToast()
            setTimeout(() => {this.$router.back()}, 2000)
          }else{
            this.handleError()
          }
        })
        .catch((error)=>{
          this.handleError()
        })
    },

    handleError(){
      this.isLoading = false
      this.hasValidatedSupplement = false
      this.errorToast()
    },

    successToast () {
      this.$bvToast.toast(this.$i18n.t('Annonce') + ' ' + this.$i18n.t('f.modified'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        variant: 'success',
        title: this.$i18n.t('Success'),
      })
    },

    errorToast () {
      this.$bvToast.toast(this.$i18n.t('Error'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        variant: 'error',
        title: this.$i18n.t('Error.title'),
      })
    },
  }
}
</script>

<style scoped>
/* pour affichage desktop (md) : scroll pas sur la page entière mais sur le contenu modifiable uniquement */
@media (min-width: 769px) {

  #annonce-add-reward-container {
    height: calc(89vh - 100px);
    max-height: calc(89vh - 100px);
  }

  #annonce-add-reward-title-container {
    height: 100px;
  }

  #annonce-add-reward-sub-container {
    height: calc(100% - 100px);
  }

  #annonce-add-reward-sub-container-right {
    height: 100%;
  }
}

@media (max-width: 768px) {
  #annonce-add-reward-sub-container-right {
    margin-bottom: 100px;
  }
}

.custom-width {
  width: 50%;
}

.col-title {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-annonce-add-reward {
  background-color: var(--main-black-dark);
  position: fixed;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 100px;
  z-index: 10;
}

.button-spinner.spinner-border {
  margin-left: calc(1.5rem + 28px - 0.5rem);
  margin-right: calc(1.5rem + 28px - 0.5rem);
}

@media (max-width: 768px) {

  .custom-width {
    width: 100%;
  }

  .col-title {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    justify-content: flex-start;
    align-items: flex-start;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceAdditionnalRewardEdit.vue